var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { environment } from "environments/environment";
import { FeatureFlags } from "feature-flags";
import * as i0 from "@angular/core";
// import { IMutableContext, UnleashClient } from "unleash-proxy-client";
var FeatureFlagService = /** @class */ (function () {
    function FeatureFlagService() {
        var _this = this;
        this.unleash = new window["unleash"].UnleashClient({
            url: environment.unleash.proxyUrl,
            clientKey: environment.unleash.clientKey,
            refreshInterval: environment.unleash.refreshInterval,
            appName: environment.unleash.appName,
            environment: environment.unleash.environment,
            fetch: function (input, init) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.log("UNLEASH fetch", input, init);
                    return [2 /*return*/, fetch(input, __assign({}, init, { cache: 'no-store', headers: __assign({}, init.headers, { 'Cache-Control': 'no-cache, no-store, must-revalidate', Pragma: 'no-cache', Expires: '0' }) }))];
                });
            }); },
        });
        this.userEmitted = false;
        this.ready = false;
        this.analytics = 'waiting';
        this.unleash.on("ready", function () {
            console.log("UNLEASH ready");
            _this.ready = true;
        });
        this.unleash.on("update", function () {
            console.log("UNLEASH update");
            if (_this.ready) {
                _this.analytics = _this.isEnabled(FeatureFlags.DISABLE_ANALYTICS) ? 'disabled' : 'enabled';
            }
        });
    }
    FeatureFlagService.prototype.start = function () {
        this.unleash.start();
    };
    FeatureFlagService.prototype.stop = function () {
        this.unleash.stop();
    };
    FeatureFlagService.prototype.updateContext = function (contextObj) {
        this.unleash.updateContext(contextObj);
    };
    FeatureFlagService.prototype.isEnabled = function (feature) {
        return this.unleash.isEnabled(feature);
    };
    FeatureFlagService.prototype.isUserEmitted = function () {
        return this.userEmitted;
    };
    FeatureFlagService.prototype.emitUser = function (user) {
        var capabilities = {};
        for (var key in user.OperatorCapability) {
            console.log(key);
            capabilities["capability_" + key] = user.OperatorCapability[key];
        }
        var _user = __assign({}, user, capabilities, { userId: user.id, employersId: user.Teams[0].employers_id, employerName: user.employer.name, hostName: environment.baseUrl });
        console.log("UNLEASH emitUser", _user);
        // add userId, operator capabilities
        this.updateContext(_user);
        this.userEmitted = true;
    };
    FeatureFlagService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureFlagService_Factory() { return new FeatureFlagService(); }, token: FeatureFlagService, providedIn: "root" });
    return FeatureFlagService;
}());
export { FeatureFlagService };
